const Vue = window.Vue

Vue.component("BasketPreviewContent", () => import("./app/components/basket/BasketPreviewContent.vue"))
